import script from "./FormVueSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormVueSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormVueSelect.vue?vue&type=style&index=0&id=117c1d88&lang=css"

const __exports__ = script;

export default __exports__